module.exports = __webpack_public_path__ + "static/media/Precision.c8c17f42.svg";